const APP_API_ROUTE = "http://localhost:9000/";

export default APP_API_ROUTE;
